import { gql } from "apollo-boost";
import { ContentLoader } from 'components/common/loader/ContentLoader';
import { Wrapper } from 'components/common/utils/wrapper/Wrapper';
import * as React from 'react';
import { Subscription } from "react-apollo";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import EventDucks from 'stores/ducks/Event.duck';
import UIDucks from 'stores/ducks/UI.duck';
import UserDucks from 'stores/ducks/User.duck';
import CardView from './CardView';
import ListView from './ListView';


const newEvents = gql`
  subscription {
    updatedEvents{
      id
      name
      location
      isActive,
      revenueTotal,
      stripeFeeTotal,
      platFormFeeTotal,
      styling{promoImg}
      totalPrivate,
      totalPublic,
      hosts
      payoutTime
      createdBy
      onSale
      currency
    }
  }
`;

interface IDashboardOverviewProps {
  token?: string;
  dispatch?: any;
  events?: any[];
  isOpened?: any;
  user?: any;
  state?: any;
}

/**
 * Loads all upcoming and finished event cards to the screen.
 */
class ManageEventsPage extends React.Component<IDashboardOverviewProps> {

  public state = {
    filter: "active",
    loading: false,
    searchTerm: '',
    resultFound: false,
    result: [''],
    updatedEvents: [],
    updateString: 0,
    switched: false
  };

  constructor(props) {
    super(props);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.setNewEvents = this.setNewEvents.bind(this);
    this.toggleSwitch = this.toggleSwitch.bind(this);
  }

  public handleFilterChange(filter: string | null) {
    this.setState({ filter });
  }

  public toggleSwitch() {
    this.setState({
      switched: !this.state.switched
    });
  };

  public runSearch(e: any) {
    if (e.target.value === '') {
      this.setState({ searchTerm: '', resultFound: false, result: [''] })
      return;
    }
    this.setState({ loading: true, searchTerm: e.target.value })
    fetchGraphQL(
      `
            {
              event {
                search(searchTerm:"${e.target.value}") 
              }
            }
      `,
      undefined
    ).then(result => {
      if (result.event.search.length !== 0) {
        this.setState({ loading: false, resultFound: true, result: result.event.search })
      } else {
        this.setState({ loading: false, resultFound: true, result: [''] })
      }
    })
  }

  public componentDidMount() {
    this.setState({ loading: true })
    fetchGraphQL(
      `
            {
              event {
                getByCurrentUser {
                  id
                  name
                  location
                  isActive,
                  revenueTotal,
                  stripeFeeTotal,
                  platFormFeeTotal,
                  styling{promoImg}
                  totalPrivate,
                  totalPublic,
                  hosts
                  currency
                  onSale
                  promoters
                  checkers
                  payoutTime
                  createdBy
                  timeObject {
                    startYear
			        			startMonth
			            	startDay
			              startHour
			              startMinutes
                    startAMPM
                    endYear
                    endMonth
                    endDay
                    endHour
                    endMinutes
                    endAMPM
                  }
                }
              }
            }
          `,
      undefined
    ).then(result => {
      if (result) {
        // sorting events in chronological order
        const sortedEvents = result.event.getByCurrentUser.sort((s, e) => {
          const startTime = new Date(s.timeObject.startYear, s.timeObject.startMonth - 1, s.timeObject.startDay, s.timeObject.startAMPM ? s.timeObject.startHour + 12 : s.timeObject.startHour, s.timeObject.startMinutes)
          const endTime = new Date(e.timeObject.startYear, e.timeObject.startMonth - 1, e.timeObject.startDay, e.timeObject.startAMPM ? e.timeObject.startHour + 12 : e.timeObject.startHour, e.timeObject.startMinutes)
          if (startTime < endTime) { return 1 } else if (startTime > endTime) { return -1 } else { return 0 }
        })
        this.props.dispatch(EventDucks.setUserEvents([...sortedEvents]));
        this.setState({ loading: false })
      }
    });
    if (!this.props.isOpened) {
      return;
    }
    this.props.dispatch(UIDucks.setAppBar(!this.props.isOpened));
  }

  public setNewEvents(updatedEvents: any) {
    this.setState({
      updatedEvents
    })
    fetchGraphQL(
      `
            {
              event {
                getByCurrentUser {
                  id
                  name
                  location
                  isActive,
                  revenueTotal,
                  stripeFeeTotal,
                  platFormFeeTotal,
                  styling{promoImg}
                  totalPrivate,
                  totalPublic,
                  hosts
                  onSale
                  currency
                  promoters
                  checkers
                  payoutTime
                  createdBy
                  timeObject {
                    startYear
			        			startMonth
			            	startDay
			              startHour
			              startMinutes
                    startAMPM
                    endYear
                    endMonth
                    endDay
                    endHour
                    endMinutes
                    endAMPM
                  }
                }
              }
            }
          `,
      undefined
    ).then(result => {
      if (result) {
        fetchGraphQL(
          `query {
            user {
              getRelatedEvents(userId:"${this.props.user!}")
            }
          }
          `
        ).then(res => {
          const events = {};
          JSON.parse(res.user.getRelatedEvents).events.forEach((item, index) => {
            events[String(index)] = item;
          })
          const user = {
            ...this.props.user,
            events
          }
          // sorting events in chronological order
          const sortedEvents = result.event.getByCurrentUser.sort((s, e) => {
            const startTime = new Date(s.timeObject.startYear, s.timeObject.startMonth - 1, s.timeObject.startDay, s.timeObject.startAMPM ? s.timeObject.startHour + 12 : s.timeObject.startHour, s.timeObject.startMinutes)
            const endTime = new Date(e.timeObject.startYear, e.timeObject.startMonth - 1, e.timeObject.startDay, e.timeObject.startAMPM ? e.timeObject.startHour + 12 : e.timeObject.startHour, e.timeObject.startMinutes)
            if (startTime < endTime) { return 1 } else if (startTime > endTime) { return -1 } else { return 0 }
          })
          this.props.dispatch(UserDucks.setUser(user));
          this.props.dispatch(EventDucks.setUserEvents([...sortedEvents]));
        })
      }
    });
    if (!this.props.isOpened) {
      return undefined;
    }
    this.props.dispatch(UIDucks.setAppBar(!this.props.isOpened));
    return undefined
  }

  public render() {

    if (this.props.events !== undefined) {
      let inactiveEvents = this.props.events.filter((item) => {
        return !item.isActive;
      }).reverse()

      let activeEvents = this.props.events.filter((item) => {
        return item.isActive;
      }).reverse()

      if (this.props.state.UI.resultFound) {
        activeEvents = activeEvents.filter((item) => {
          return this.props.state.UI.result.includes(item.name)
        })

        inactiveEvents = inactiveEvents.filter((item) => {
          return this.props.state.UI.result.includes(item.name)
        })
      }

      const Ids: string[] = [];
      this.props.events.forEach((item) => {
        Ids.push(item.id)
      })

      return (
        <div>
          <Subscription subscription={newEvents}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.updatedEvents !== null && data.updatedEvents !== this.state.updatedEvents) {
                return <img height={0} width={0} onLoad={this.setNewEvents(data.updatedEvents)} style={{ display: 'none' }} />
              }
              return null;
            }}
          </Subscription>
          <ContentLoader isLoading={this.state.loading}>
            <Wrapper className="container" >
              {
                !this.state.switched ?
                  <CardView user={this.props.user} events={this.props.events} inactiveEvents={inactiveEvents.reverse()} activeEvents={activeEvents} filter={this.state.filter} />
                  : <ListView events={this.props.events} inactiveEvents={inactiveEvents.reverse()} activeEvents={activeEvents} filter={this.state.filter} />
              }
            </Wrapper>
          </ContentLoader>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = state => {
  return {
    events: EventDucks.getEvents(state),
    isOpened: UIDucks.getIsAppBarOpen(state),
    user: UserDucks.getUser(state),
    state: UIDucks.getState(state)
  };
};
export default withRouter(connect(mapStateToProps)(ManageEventsPage));



// WEBPACK FOOTER //
// ./src/pages/manage/events/manage/ManageEvents.page.tsx